<div class="contact-form contact-form-inputs-filled contact-form-inputs-circle contact-form-button-block contact-form-button-circle mb-60 mt-40">
  <form action="" method="post">
    <form action="" method="post">
      <div class="moneto-loading" *ngIf="loadingFromQrCode">
        <p>Wird geladen...</p>
      </div> 
      <div class="row">
        <div class="lqd-column col-md-12 mb-5">
          <h2 class="pr-md-7 mb-30" appTranslate="card.title"></h2>
          <p appTranslate="card.text.1"></p>
          <p appTranslate="card.text.2"></p>
        </div>
        <div class="lqd-column col-md-8 pt-md-6 moneto-id-verification">
          <div class="desktop-workflow">
            <div class="row">
              <div *ngIf="broadcast">
                <input type="text" name="card_recto" [value]="broadcast.card_recto" required>
                <input type="text" name="card_verso" [value]="broadcast.card_verso" required>
              </div>
            </div>
          </div>

          <div class="mobile-workflow">
            <div class="lqd-column col-md-6">
              <h3 class="pr-md-7 mb-10" appTranslate="card.front"></h3>
              <div *ngIf="broadcast" class="broadcast-cards row">
                <div *ngIf="broadcast.card_recto" class="lqd-column col-md-12">
                  <div><img [src]="broadcast.card_recto" alt="front" class="broadcast-recto"></div>
                </div>
              </div>
              <div class="file is-centered is-large is-boxed">
                <app-file-input name="card-recto" (fileReady)="onFileReady($event, front)"></app-file-input>
              </div>
            </div>
            <div class="lqd-column col-md-6">
              <h3 class="pr-md-7 mb-10" appTranslate="card.back"></h3>
              <div *ngIf="broadcast" class="broadcast-cards row">
                <div *ngIf="broadcast.card_verso" class="lqd-column col-md-12">
                  <div><img [src]="broadcast.card_verso" alt="back" class="broadcast-verso"></div>
                </div>
              </div>
              <div class="file is-centered is-large is-boxed">
                <app-file-input name="card-verso" (fileReady)="onFileReady($event, back)"></app-file-input>
              </div>
            </div>
          </div>
        </div>

        <div class="lqd-column col-md-4 text-center moneto-qr-code">
          <p appTranslate="mobile.qrCode"></p>
          <img src="{{ getQrCode() }}" alt="qrcode">
          <p class="mt-6 url"><a [href]="url" target="_blank">{{ url }}</a></p>
        </div>

      </div>

      <!-- <div class="row">

        <div class="lqd-column col-md-6 text-center">
          <h3 appTranslate="mobile.url"></h3>
          <h3 class="mt-6 url"><a [href]="url" target="_blank">{{ url }}</a></h3>
        </div>
      </div> -->

      <div class="row mt-20">
        <div class="mobile-workflow">
          <div class="lqd-column col-md-4">
            <h2 class="pr-md-7 mb-30" appTranslate="signature.title"></h2>
            <span style="display: inline-block;">
              <p appTranslate="signature.text.1" style="display: inline;"></p>
              <span *ngIf="!isMobile">
                (<a 
                  (click)="showDocument()" 
                  style="text-decoration: underline; color: #00aced; cursor: pointer;"
                  target="showDocument"
                  >siehe Vorschau</a>).
              </span>
              <span *ngIf="isMobile && generatedLink == '' && !isGenerateDocumentLoading">
                (<a 
                  (click)="showDocument()" 
                  style="text-decoration: underline; color: #00aced; cursor: pointer;"
                  target="_blank"
                  >Vorschau laden.</a>)
              </span>

              <span *ngIf="isMobile && generatedLink != ''">
                  (<a 
                    [href]="generatedLink"
                    style="text-decoration: underline; color: #00aced; cursor: pointer;"
                    target="_blank"
                    >Vorschau anzeigen</a>).
              </span>

              <div
                class="moneto-inline-loader"
                *ngIf="isGenerateDocumentLoading"></div>
            </span>
            <p appTranslate="signature.text.2"></p>
          </div>
          <div class="lqd-column col-md-8 pt-md-6">
            <div class="wrapper mt-4" style="position: relative;width: 402px;height: 202px;border:1px solid #505050;-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;user-select: none;">
              <app-canvas class="signature-pad" width="400" height="200" (end)="onDrawEnd()"></app-canvas>
            </div>
            <div>
              <button (click)="reset()" id="clear" class="btn btn-default btn-naked mt-1 text-uppercase bg-white text-hover-primary btn-xsm circle btn-bordered border-thin font-size-12 lh-15 font-weight-bold ltr-sp-05 mb-2">
                <span><span class="btn-txt" appTranslate="signature.clear"></span></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </form>
</div>
